import { useEffect, useState } from "react";
import { Loader2, ShieldAlert, LogIn } from "lucide-react";
import { getMe, logout, startGoogleLogin } from "./adminApi";
import AdminDashboard from "./AdminDashboard";

export default function AdminPage() {
  const [status, setStatus] = useState("loading"); // loading | login | forbidden | admin
  const [user, setUser] = useState(null);

  useEffect(() => {
    getMe()
      .then((u) => {
        setUser(u);
        setStatus(u.is_admin ? "admin" : "forbidden");
      })
      .catch(() => setStatus("login"));
  }, []);

  if (status === "loading") {
    return (
      <Shell>
        <div className="flex items-center gap-3 text-white/70" data-testid="admin-loading">
          <Loader2 className="animate-spin" size={20} /> Loading…
        </div>
      </Shell>
    );
  }

  if (status === "login") {
    return (
      <Shell>
        <div className="text-center max-w-sm" data-testid="admin-login">
          <img
            src="https://customer-assets.emergentagent.com/job_3a60f548-c5b2-42d1-8621-c1256f564833/artifacts/6rc1wefw_XLKMGLogo%20copy.png"
            alt="Knight Media Group"
            className="w-44 h-auto mx-auto mb-8 mix-blend-screen select-none"
            data-testid="admin-logo"
          />
          <div className="font-bold text-white text-3xl mb-3">Admin Access</div>
          <p className="text-white/60 mb-8 leading-relaxed">
            Sign in with your authorized Google account to manage the Work portfolio.
          </p>
          <button
            onClick={startGoogleLogin}
            className="btn-kmg inline-flex items-center justify-center gap-2 bg-[#1440E1] hover:bg-[#1033B3] text-white px-7 py-3.5 rounded-full font-bold tracking-wide w-full"
            data-testid="login-google-btn"
          >
            <LogIn size={18} /> Continue with Google
          </button>
        </div>
      </Shell>
    );
  }

  if (status === "forbidden") {
    return (
      <Shell>
        <div className="text-center max-w-md" data-testid="admin-forbidden">
          <ShieldAlert className="text-[#ff9b9b] mx-auto mb-4" size={40} />
          <div className="font-bold text-white text-2xl mb-3">Not authorized</div>
          <p className="text-white/60 mb-6 leading-relaxed">
            You're signed in as <span className="text-white">{user?.email}</span>, but this
            account isn't on the admin allowlist.
          </p>
          <button
            onClick={() => logout().then(() => window.location.reload())}
            className="text-white/70 hover:text-white underline text-sm"
            data-testid="forbidden-logout-btn"
          >
            Sign out
          </button>
        </div>
      </Shell>
    );
  }

  return <AdminDashboard user={user} />;
}

function Shell({ children }) {
  return (
    <div className="min-h-screen bg-[#050B26] flex items-center justify-center px-6 text-white antialiased">
      {children}
    </div>
  );
}
